import Collection from '@/models/Collection'
import { ModuleDataItem } from '@/models/ModuleDataItem'

export class ModuleData extends Collection {

	public models!: ModuleDataItem[]

	public defaults() {
		return {
			name: '',
		}
	}

	public model() {
		return ModuleDataItem
	}

	public routes() {
		return {
			fetch: 'entries/{name}',
		}
	}
}
